/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TemplatesImport } from './routes/templates'
import { Route as StripeImport } from './routes/stripe'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SettingsImport } from './routes/settings'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as FeedbackImport } from './routes/feedback'
import { Route as AnalyticsImport } from './routes/analytics'
import { Route as IndexImport } from './routes/index'
import { Route as VisitsIndexImport } from './routes/visits/index'
import { Route as VisitsVisitIdImport } from './routes/visits/$visitId'
import { Route as TemplateNewImport } from './routes/template/new'
import { Route as TemplateTemplateIdImport } from './routes/template.$templateId'

// Create/Update Routes

const TemplatesRoute = TemplatesImport.update({
  path: '/templates',
  getParentRoute: () => rootRoute,
} as any)

const StripeRoute = StripeImport.update({
  path: '/stripe',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const FeedbackRoute = FeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => rootRoute,
} as any)

const AnalyticsRoute = AnalyticsImport.update({
  path: '/analytics',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const VisitsIndexRoute = VisitsIndexImport.update({
  path: '/visits/',
  getParentRoute: () => rootRoute,
} as any)

const VisitsVisitIdRoute = VisitsVisitIdImport.update({
  path: '/visits/$visitId',
  getParentRoute: () => rootRoute,
} as any)

const TemplateNewRoute = TemplateNewImport.update({
  path: '/template/new',
  getParentRoute: () => rootRoute,
} as any)

const TemplateTemplateIdRoute = TemplateTemplateIdImport.update({
  path: '/template/$templateId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsImport
      parentRoute: typeof rootRoute
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/stripe': {
      id: '/stripe'
      path: '/stripe'
      fullPath: '/stripe'
      preLoaderRoute: typeof StripeImport
      parentRoute: typeof rootRoute
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesImport
      parentRoute: typeof rootRoute
    }
    '/template/$templateId': {
      id: '/template/$templateId'
      path: '/template/$templateId'
      fullPath: '/template/$templateId'
      preLoaderRoute: typeof TemplateTemplateIdImport
      parentRoute: typeof rootRoute
    }
    '/template/new': {
      id: '/template/new'
      path: '/template/new'
      fullPath: '/template/new'
      preLoaderRoute: typeof TemplateNewImport
      parentRoute: typeof rootRoute
    }
    '/visits/$visitId': {
      id: '/visits/$visitId'
      path: '/visits/$visitId'
      fullPath: '/visits/$visitId'
      preLoaderRoute: typeof VisitsVisitIdImport
      parentRoute: typeof rootRoute
    }
    '/visits/': {
      id: '/visits/'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof VisitsIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AnalyticsRoute,
  FeedbackRoute,
  ForgotPasswordRoute,
  SettingsRoute,
  SignUpRoute,
  StripeRoute,
  TemplatesRoute,
  TemplateTemplateIdRoute,
  TemplateNewRoute,
  VisitsVisitIdRoute,
  VisitsIndexRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.ts",
      "children": [
        "/",
        "/analytics",
        "/feedback",
        "/forgot-password",
        "/settings",
        "/sign-up",
        "/stripe",
        "/templates",
        "/template/$templateId",
        "/template/new",
        "/visits/$visitId",
        "/visits/"
      ]
    },
    "/": {
      "filePath": "index.ts"
    },
    "/analytics": {
      "filePath": "analytics.ts"
    },
    "/feedback": {
      "filePath": "feedback.ts"
    },
    "/forgot-password": {
      "filePath": "forgot-password.ts"
    },
    "/settings": {
      "filePath": "settings.ts"
    },
    "/sign-up": {
      "filePath": "sign-up.ts"
    },
    "/stripe": {
      "filePath": "stripe.ts"
    },
    "/templates": {
      "filePath": "templates.ts"
    },
    "/template/$templateId": {
      "filePath": "template.$templateId.ts"
    },
    "/template/new": {
      "filePath": "template/new.ts"
    },
    "/visits/$visitId": {
      "filePath": "visits/$visitId.ts"
    },
    "/visits/": {
      "filePath": "visits/index.ts"
    }
  }
}
ROUTE_MANIFEST_END */
